import type {ThemeOptions} from '@mui/material';
import type {ThemeModes} from '../types';
import {darkPalette} from './palette-dark';
import {lightPalette} from './palette-light';

export const themeModeToPalette: Record<ThemeModes, ThemeOptions['palette']> = {
  dark: darkPalette,
  light: lightPalette,
};
